/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * BookCard style
 *
 * @file BookCardStyles.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';

const navButtonV1Styles = {
  minWidth: 'unset',
  alignSelf: 'center',
  width: 32,
  height: 32,
  borderRadius: 40,
  zIndex: 2,
  border: `1px solid ${mixins.lightTextColor2})`,
  background: mixins.lightBgColor2,
  position: 'absolute',
  top: '40%',
  display: 'inline-flex !important',
  color: mixins.lightTextColor2,
  '& span': {
    height: 16,
    width: 16,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '& .MuiSvgIcon-root': {
    fontSize: '16px !important',
    width: '16px !important',
    height: '16px !important',
    paddingLeft: 0
  },
  '&:hover': {
    border: `1px solid ${mixins.lightTextColor2})`,
    background: mixins.lightBgColor2
  },
  '&:focus-visible': {
    background: mixins.swatchDarkFont,
    outline: `2px solid ${mixins.secondaryButtonFocusColor})`,
    '&::after': {
      border: 'none'
    }
  }
};

const contentNavV1Styles = {
  '&[aria-disabled="true"]': {
    opacity: 0.32,
    backdropFilter: 'blur(12px)',
    pointerEvents: 'none',
    cursor: 'default',
    '&:focus-visible': {
      outline: 'none'
    }
  }
};

export const StyledSlideArrowRight = styled(IconButton)({
  '&&': {
    ...navButtonV1Styles,
    ...contentNavV1Styles,
    display: 'block !important',
    top: '-54px',
    right: '0px'
  }
});

export const StyledSlideArrowLeft = styled(IconButton)({
  '&&': {
    ...navButtonV1Styles,
    ...contentNavV1Styles,
    transform: 'rotate(180deg)',
    display: 'block !important',
    right: '41px',
    top: '-54px',
    left: 'auto'
  }
});
